import { gql } from '@apollo/client';
import { PUBLISH_FIELDS } from './publishing';

export const MY_SCHEDULED_PUBLISHES = gql`
  ${PUBLISH_FIELDS}
  query MyScheduledPublishes($from: DateTime!, $to: DateTime!) {
    myScheduledPublishes(from: $from, to: $to) {
      ...PublishFields
    }
  }
`;

export const MY_POSTABLE_CLIPS = gql`
  query MyPostableClips($search: String, $limit: Int, $offset: Int) {
    myPostableClips(search: $search, limit: $limit, offset: $offset) {
      id
      name
      thumbnail_url
      finished_video_url
      createdAt
    }
  }
`;

export const MY_CLIP_DISPLAY = gql`
  query MyClipDisplay($id: ID!) {
    myClip(id: $id) {
      id
      name
    }
  }
`;

export const CREATE_MY_SCHEDULED_PUBLISH = gql`
  ${PUBLISH_FIELDS}
  mutation CreateMyScheduledPublish($input: ScheduledPublishInput!) {
    createMyScheduledPublish(input: $input) {
      ...PublishFields
    }
  }
`;

export const UPDATE_MY_SCHEDULED_PUBLISH = gql`
  ${PUBLISH_FIELDS}
  mutation UpdateMyScheduledPublish($id: ID!, $input: ScheduledPublishInput!) {
    updateMyScheduledPublish(id: $id, input: $input) {
      ...PublishFields
    }
  }
`;

export const CANCEL_MY_SCHEDULED_PUBLISH = gql`
  mutation CancelMyScheduledPublish($id: ID!) {
    cancelMyScheduledPublish(id: $id)
  }
`;
